<div id="content" class="allcp-form" ng-controller="StationController" ng-init="get()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-7">
                <h5> Edit Station</h5>
                <hr>
                <form ng-submit="update()" autocomplete="off" class="form-horizontal allcp-form">
                    <div class="form-group row">
                        <label class="col-md-3 control-label">
                            Station Code *
                        </label>
                        <div class="col-md-9">
                            <label for="code" class="field">
                                <input type="text" ng-model="data.station.code" class="gui-input br-light light"
                                    placeholder="Station Code" required>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 control-label">
                            Station State *
                        </label>
                        <div class="col-md-9">
                            <label for="state" class="field">
                                <select ng-model="data.station.state" class="form-control gui-input br-light light">
                                    <option value="">Select State</option>
                                    <option value="{{ state.name }}" ng-repeat="state in states track by $index">
                                        {{ state.name }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 control-label">
                            Station City *
                        </label>
                        <div class="col-md-9">
                            <label for="code" class="field">
                                <input type="text" ng-model="data.station.city" class="gui-input br-light light"
                                    placeholder="Station City" required>
                            </label>
                        </div>
                    </div>
                    <!-- <div class="form-group row">
					<label class="col-md-3 control-label">
						Station Label *
					</label>
					<div class="col-md-9">
						<label for="label" class="field">
							<input type="text" ng-model="data.station.label" class="gui-input br-light light" placeholder="Station Label" required>
						</label>
					</div>
				</div> -->
                    <div class="form-group row">
                        <label class="col-md-3 control-label">
                            Address *
                        </label>
                        <div class="col-md-9">
                            <label for="address" class="field">
                                <input google-place autocomplete="false" type="text" class="form-control input-md"
                                    placeholder="Station Address" ng-model="data.station.address"
                                    ng-change="getAddress(data.station.address)" id="googlePlaceInput" required>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 control-label">
                            Zipcode *
                        </label>
                        <div class="col-md-9">
                            <label for="zipcode" class="field">
                                <input type="text" ng-model="data.station.zipcode" class="gui-input br-light light"
                                    placeholder="Zipcode" required>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="store-desc" class="col-md-3 control-label">
                            Zipcodes * :
                            <a href="#" class="hint--medium hint--top"
                                aria-label="Enter zipcode connected to this station">
                                <i class="fa fa-question"></i>
                            </a>
                        </label>
                        <div class="col-md-9">
                            <ui-select 
                                multiple 
                                tagging 
                                tagging-tokens=",|SPACE|ENTER"
                                tagging-label="add zipcode" 
                                ng-model="data.station.zipcodes"
                                theme="bootstrap" 
                                sortable="true" 
                                class="gui-input br-light light" 
                                style="width: 100%;"
                                title="Enter Zipcode">
                                <ui-select-match placeholder="Enter Zipcodes...">{{$item}}</ui-select-match>
                                <ui-select-choices repeat="tag in ctrl.availableColors | filter:$select.search">
                                    {{tag.zipcode}}
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-9">
                            <button type="submit" class="btn btn-primary pull-right"><span class="fa fa-edit"></span>
                                Güncelle</a>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-5">
                <div id="mapStation" style="height:400px; margin-top:30px;"></div>
            </div>
        </div>
    </div>
</div>